import React, { useState } from 'react';
import { useQuery } from '@apollo/client/react';
import { GET_CONTACT_ACTIVITY_FEED } from '../../../../lib/graphql/queries/contacts';
import type { GQLActivityFeedItem } from '../../../../hooks/graphql/contacts/useContact';
import { CrmNotesHistoryView } from './CrmNotesHistoryView';

interface Props { contactId: string; organizationId: string; timezone?: string }
interface Data {
  contact: { activityFeed: { items: GQLActivityFeedItem[]; total: number; hasMore: boolean } } | null;
}

// Keyed by org/contact below so pagination cannot leak across selected contacts.
const History: React.FC<Props> = ({ contactId, organizationId, timezone }) => {
  const [page, setPage] = useState(0);
  const { data, loading, error, refetch } = useQuery<Data>(GET_CONTACT_ACTIVITY_FEED, {
    variables: { organizationId, contactId, eventTypes: ['crm_note'], limit: 50, offset: page * 50 },
    skip: !organizationId || !contactId,
    fetchPolicy: 'cache-and-network',
    notifyOnNetworkStatusChange: true,
  });
  const feed = data?.contact?.activityFeed;
  return <CrmNotesHistoryView items={feed?.items ?? []} total={feed?.total ?? 0}
    page={page} hasMore={feed?.hasMore ?? false} loading={loading}
    error={!!error || (!loading && !data?.contact)} timezone={timezone}
    onPrevious={() => setPage((p) => Math.max(0, p - 1))}
    onNext={() => setPage((p) => p + 1)} onRetry={() => { void refetch().catch(() => {}); }} />;
};

export const CrmNotesHistory: React.FC<Props> = (props) => (
  <History key={`${props.organizationId}:${props.contactId}`} {...props} />
);
